var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 14.8008V14.918H12.5078V14.8008C12.5371 13.209 12.9961 12.5059 14.168 11.793C15.4082 11.0312 16.1602 9.98633 16.1602 8.41406C16.1602 6.1875 14.4609 4.66406 11.9219 4.66406C9.59766 4.66406 7.72266 6.02148 7.64453 8.51172H9.75391C9.8418 7.06641 10.8672 6.42188 11.9219 6.42188C13.0938 6.42188 14.0312 7.19336 14.0312 8.41406C14.0312 9.43945 13.4062 10.1621 12.5859 10.6602C11.2969 11.4609 10.5449 12.2422 10.5156 14.8008ZM10.2031 17.75C10.1934 18.5117 10.8281 19.127 11.5898 19.1367C12.3418 19.127 12.9668 18.5117 12.9766 17.75C12.9668 16.9883 12.3418 16.3633 11.5898 16.3633C10.8281 16.3633 10.1934 16.9883 10.2031 17.75Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/Q.73a7880818e1a472e851929b50659bb3.svg";
export { ForwardRef as ReactComponent };